import { render, staticRenderFns } from "./UpdateStockHistory.vue?vue&type=template&id=33e9cf97"
import script from "./UpdateStockHistory.vue?vue&type=script&lang=js"
export * from "./UpdateStockHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports